import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-az-input',
  imports: [FormsModule],
  templateUrl: './az-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./az-input.component.scss'],
})
export class AzInputComponent {
  @Input() value = '';
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() type: 'text' | 'email' | 'tel' | 'number' = 'text';
  @Output() valueChange = new EventEmitter<string>();

  onInputChange(value: string): void {
    this.valueChange.emit(value);
  }
}
